<template>
  <unicon :name="name" fill="#f2f2f0" class="icon--1 w-6 h-6" />
</template>

<script>
export default {
  name: 'SideNavItemIcon',
  props: {
    name: {
      type: String,
      required: true
    }
  }
}
</script>
